/**
 * assets/product-koishow-tegoed.js
 * Koishow-tegoedbadge in de buy-box van snippets/product-buy-box.liquid
 *
 * Rekent het tegoed om naar het gekozen aantal. Leest het bedrag per stuk uit
 * data-ksw-bedrag en luistert gedelegeerd op document, zodat het ook werkt
 * met een verse hoeveelheidsteller. Zie ARCHITECTURE.md sectie 11.
 */

(function(){
  var box=document.querySelector('[data-ksw-box]'); if(!box) return;
  var per=parseInt(box.getAttribute('data-ksw-bedrag'),10)||0;
  var badge=box.querySelector('[data-ksw-badge]'), kop=box.querySelector('[data-ksw-kop]');
  function verversen(){
    var inp=document.querySelector('[data-qty-input]');
    var n=Math.max(1,parseInt(inp&&inp.value,10)||1);
    var totaal=per*n;
    badge.textContent='\u20ac'+totaal;
    kop.textContent = n>1
      ? 'Je krijgt \u20ac'+totaal+' winkeltegoed ('+n+' x \u20ac'+per+')'
      : 'Je krijgt \u20ac'+per+' winkeltegoed';
  }
  document.addEventListener('input',function(e){ if(e.target.matches('[data-qty-input]')) verversen(); });
  document.addEventListener('click',function(e){ if(e.target.closest('[data-qty-plus],[data-qty-minus]')) setTimeout(verversen,0); });
  verversen();
})();
